module.exports = __webpack_public_path__ + "img/2.49c231b8.png";